import React, { useState, useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

const WhatsAppSupport = inject('generalSettingsStore')(observer(({ generalSettingsStore }) => {
  const [isVisible, setIsVisible] = useState(false);
  const t = useTranslations('WhatsApp');
  const whatsappNumber = generalSettingsStore?.contactsAndSocial?.whatsapp;

  useEffect(() => {
    // Show the button after a short delay to avoid immediate appearance
    const timer = setTimeout(() => {
      if (whatsappNumber) {
        setIsVisible(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [whatsappNumber]);

  const openWhatsApp = () => {
    if (!whatsappNumber) return;

    // Clean the phone number (remove any non-numeric characters except +)
    const cleanNumber = whatsappNumber.replace(/[^0-9+]/g, '');

    // Get the translated message
    const message = t('support_message');

    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;

    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
  };

  if (!whatsappNumber) {
    return null;
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5, x: -20 }}
          animate={{ opacity: 1, scale: 1, x: 0 }}
          exit={{ opacity: 0, scale: 0.5, x: -20 }}
          transition={{ duration: 0.3 }}
          onClick={openWhatsApp}
          className="fixed bottom-6 left-6 p-3 rounded-full shadow-lg hover:shadow-xl z-[40] bg-green-500 hover:bg-green-600"
          aria-label="Contact us on WhatsApp"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <motion.div
            initial={{ scale: 1 }}
            animate={{ scale: [1, 1.1, 1] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <Image
              src="/images/whatsapp_Icon.png"
              alt="WhatsApp"
              width={24}
              height={24}
              className="w-6 h-6"
            />
          </motion.div>
        </motion.button>
      )}
    </AnimatePresence>
  );
}));

export default WhatsAppSupport;